import React from 'react';

/**
 * PublicLayout is a clean shell for public-facing pages.
 */
export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center py-8 md:py-16 px-4">
      <div className="w-full max-w-2xl bg-white rounded-[2.5rem] shadow-2xl shadow-indigo-200/40 overflow-hidden ring-1 ring-gray-200">
        {children}
      </div>
      
      <div className="mt-12 flex flex-col items-center gap-3">
        <div className="text-2xl font-black text-indigo-700 tracking-tighter">
          Sportiko<span className="text-indigo-400">Forms</span>
        </div>
        <p className="text-[10px] text-gray-400 font-bold uppercase tracking-[0.2em] bg-gray-200/50 px-3 py-1 rounded-full">
          Powered by Sportiko SaaS
        </p>
      </div>
    </div>
  );
}